import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

function getName(param) {
  return get(param, 'name');
}

export function convertPreVisitFormData(formatMessage, appointment) {
  if (isEmpty(appointment)) return null;
  const { visitReason, visitType, service, providerInfo } = appointment;

  return [
    [
      {
        title: formatMessage({ id: 'profile.actions.provider' }),
        subtitle: getName(providerInfo),
      },
      {
        title: formatMessage({ id: 'surveys.preVisit.serviceType' }),
        subtitle: getName(service),
      },
    ],
    [
      {
        title: formatMessage({ id: 'surveys.preVisit.visitType' }),
        subtitle: getName(visitType),
      },
      {
        title: formatMessage({ id: 'fields.reasonType' }),
        subtitle: visitReason,
      },
    ],
  ];
}

export const isPreVisitForm = type => type === 'pre_visit';



// WEBPACK FOOTER //
// ./src/components/Surveys/utils/preVisitForm.js